<app-header></app-header>

<!-- <app-loader *ngIf="isLoading"></app-loader> -->

<div class="content-wrapper my-5 p-t-25 dis-flex">
  <div *ngIf="isSidebarOpen" class="sidebar">
    <app-sidebar
      (outcomeSelection)="onDropdownSelection($event)"
      [isOutcome]="true"
      (close)="toggleSidebar()"
      [outcomeListParentGroup]="outcomeListParentGroup"
      [outcomeTeamMembers]="outcomeTeamMembers"
      [selectOutcomeSubGroupsData]="selectOutcomeSubGroupsData"
      [businessThemeLists]="businessThemeLists"
      (onOutcomeTeamberSearch)="onOutcomeTeamberSearch($event)"
      (onelectOutcomeSubGroupsData)="onelectOutcomeSubGroupsData($event)"
    ></app-sidebar>
  </div>

  <div class="main-content p-t-20">
    <div class="container-fluid">
      <div>
        <p-breadcrumb
          class="max-w-full"
          [model]="breadCrumbItems"
          [home]="breadCrumbHome"
        >
          <ng-template pTemplate="item" let-item>
            <p class="b2 m-b-0">{{ item.label }}</p>
          </ng-template>
          <ng-template pTemplate="separator"> / </ng-template>
        </p-breadcrumb>
      </div>
      <div class="dis-flex flex-m flex-sb">
        <h1 class="font-medium m-b-0" ngbTooltip="Medium Term Outcomes">MTO</h1>
        <div class="dis-flex">
          <div class="search-box-wrapper">
            <ng-icon
              name="hugeSearch01"
              size="16"
              class="m-r-5 lh-1-0 text-70"
            ></ng-icon>
            <input
              class="radius-8 b2 m-r-20"
              type="text"
              pInputText
              [(ngModel)]="searchText"
              (ngModelChange)="onSearchChange($event)"
              placeholder="Search"
            />
          </div>
          <button class="btn outline b2 wd-120px" (click)="toggleSidebar()">
            <ng-icon
              name="hugeFilter"
              size="16"
              class="m-r-5 lh-1-0 text-70"
            ></ng-icon>
            Filters {{ filterCount > 0 ? "(" + filterCount + ")" : "" }}
          </button>
          <button
          ngbTooltip="Clone Short Term Outcomes"
          [disabled]="isCloningSTO"
            class="btn clone-btn flex-c m-l-10 b2 wd-150px"
            (click)="cloneQuarterlyOutcomes()"
          >
            <ng-icon name="hugeCopy01" size="16" class="m-r-5 lh-1-0"></ng-icon>
         {{isCloningSTO ? 'Loading...  STO':'Clone STO '}}   
          </button>
        </div>
      </div>
      <!-- <div class="outcome-card w-full">

    <p-scroller 
    [items]="outcomes" 
    [itemSize]="50" 
    scrollHeight="800px" 
    styleClass="border-1 surface-border" 
    [style]="{'width':'100%','height': '800px'}" (onScroll)="onScroll($event)">
        <ng-template pTemplate="item" let-item let-options="options">
          {{ item.value }}
              <app-annual-outcome></app-annual-outcome>
                <app-backlog></app-backlog>
                <div class="quarterly-outcome-card">
                  <app-quarterly-outcome></app-quarterly-outcome>
                  <app-milestone></app-milestone>
                </div>
        </ng-template>
     </p-scroller> 

  </div>
  -->
      <div class="body-card" *ngIf="!isLoadingOutcomes; else shimmerEffect">
        <div
          class="outcome-card w-full"
          style="height: 800px"
        >
        <div *ngIf="outcomes?.length; else noOutcomeData">
          <app-virtual-scroll
            class="w-full"
            [data]="outcomePayload"
            [apiUrl]="outcomeUrl"
            (loadedData)="onDataLoaded($event)"
          >
            <div *ngFor="let outcome of outcomes; let i = index">
              <div class="border-20 radius-8 p-t-10 p-b-10 p-l-10 p-r-10 m-b-10">
                <app-annual-outcome
                  [index]="i"
                  [outcomeData]="outcome"
                  (outcomeDetailData)="outcomeDetailData($event)"
                  (notifyParent)="handleChildEvent($event)"
                ></app-annual-outcome>
                @if(outcome?.backlogs?.length>0){
                <!-- <app-backlog *ngFor="let backlog of outcome?.backlogs" [backlogData]="backlog"></app-backlog> -->
                } @if(detailOutcomeData?.quarterly.length>0){
                <div class="quarterly-outcome-card">
                  <!-- <app-quarterly-outcome  [quarterlyOutcomesLists]="detailOutcomeData?.quarterly" ></app-quarterly-outcome> -->
                  <!-- <app-milestone></app-milestone> -->
                </div>
                }
              </div>
            </div>
          </app-virtual-scroll>
        </div>

          <div *ngIf="loading" class="loading">Loading more data...</div>
        </div>

        <app-quick-action (notifyParent)="handleChildEvent($event)"></app-quick-action>
      </div>
    </div>
  </div>
  <!-- Clone Quarterly Outcome Modal -->
  <p-dialog
    header="Clone STO and its Milestones"
    class="action-item-modal b1 font-medium"
    [modal]="true"
    [(visible)]="cloneModal"
    [style]="{ width: '50rem' }"
  >
    <div class="wrapper p-l-20 p-r-20 p-t-25 p-b-30" *ngIf="!isLoadingShimmer;else shimmerEffect">
      <div class="dis-flex radius-8 border-20 p-t-20 p-b-20 p-l-20 p-r-20" *ngIf="cloneData?.length>0;else noOutcomeData">
        <p-table
          [value]="cloneData"
          [scrollable]="true"
          scrollHeight="50vh"
          class="clone-quarterly-table w-full "
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="text-left">Quarter</th>
              <th class="text-left" >STO </th>
              <th>Milestones Count</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr>
              <!-- Select Quarter with Rowspan -->
              <td
                *ngIf="shouldDisplayRowspan(rowIndex)"
                [attr.rowspan]="calculateRowspan(rowData?.quarter)"
              >
              <p-checkbox
              [binary]="true"
              class="m-r-10"
              [(ngModel)]="rowData.isQuarterSelected"
              (ngModelChange)="toggleQuarterSelection(rowData.quarter, $event)"
            ></p-checkbox>
                {{ rowData.quarter }}
              </td>

              <!-- Short Term Outcomes -->
              <td class="text-left">
                <p-checkbox
                  [binary]="true"
                  class="m-r-10"
                  (onChange)="toggleOutcomeSelection(rowData.quarter)"
                  [(ngModel)]="rowData.isChecked"
                ></p-checkbox>
                <span [ngbTooltip]="rowData.value">
                  {{ rowData.value | truncate : 50 }}
                </span>
              </td>

              <!-- Milestones Count -->
              <td>
                <span>{{ rowData?.milestones_count }}</span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="button-group dis-flex flex-r m-t-20 m-b-20 m-r-15">
      <button class="btn outline wd-100px m-r-10" (click)="closeCloneModal()">
        Cancel
      </button>
      <button
        class="btn primary wd-100px"
        (click)="cloneQuarterlyOutcome(outcomeIds)"
      >
        Done
      </button>
    </div>
  </p-dialog>

  <ng-template #noOutcomeData>
    <app-no-data-found></app-no-data-found>
  </ng-template>

  <ng-template #shimmerEffect>
    <app-shimmer-list [count]="4"></app-shimmer-list>
  </ng-template>
</div>
